import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../../core/pipes/translate.pipe';

@Component({
  selector: 'app-account-contact-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  template: `
    <div
      class="bg-surface rounded-3xl p-5 sm:p-6 border border-border-subtle shadow-subtle antialiased"
    >
      <div class="mb-5">
        <h4 class="text-[10px] font-black uppercase tracking-widest text-text-muted font-mono">
          {{ 'accountsInformation.contact.instantConversion' | translate }}
        </h4>
        <h3 class="text-sm sm:text-base font-black text-text-primary tracking-tight mt-0.5">
          {{ contactTitle | translate }}
        </h3>
      </div>

      <div class="space-y-2.5">
        <a
          [href]="'tel:' + (phoneNumber || '01000000000')"
          class="w-full inline-flex items-center justify-center gap-3 px-4 py-3.5 btn-gradient text-white rounded-2xl text-xs font-black uppercase tracking-widest font-mono shadow-primary-glow transition-all duration-300 active:scale-[0.97]"
        >
          <i class="fa-solid fa-phone text-xs animate-shake"></i>
          <span>{{ phoneNumber || ('accountsInformation.contact.callMobileAsset' | translate) }}</span>
        </a>

        <a
          [href]="'mailto:' + (email || 'support@homigo.com')"
          class="w-full inline-flex items-center justify-center gap-3 px-4 py-3.5 bg-surface-elevated hover:bg-surface border border-border-subtle hover:border-border-subtle rounded-2xl text-xs font-bold text-text-primary hover:text-text-primary transition-all duration-200 shadow-sm active:scale-[0.97] group"
        >
          <i
            class="fa-solid fa-envelope text-primary text-xs transition-transform group-hover:scale-110"
          ></i>
          <span class="truncate font-mono tracking-wide text-text-secondary group-hover:text-text-primary">
            {{ email || ('accountsInformation.contact.defaultEmail' | translate) }}
          </span>
        </a>
      </div>

      <div class="mt-5 pt-4 border-t border-border-subtle flex items-center justify-between">
        <div class="flex items-center gap-2">
          <div
            class="w-7 h-7 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center text-primary shrink-0"
          >
            <i class="fa-solid fa-clock-rotate-left text-[11px]"></i>
          </div>
          <div>
            <div class="text-[9px] font-black uppercase tracking-wider text-text-muted font-mono">
              {{ 'accountsInformation.contact.responsePace' | translate }}
            </div>
            <div class="text-xs font-black text-text-primary tracking-tight mt-0.5">
              {{ responseTime.startsWith('accountsInformation.') ? (responseTime | translate) : responseTime }}
            </div>
          </div>
        </div>

        <span
          class="inline-flex items-center gap-1 px-2 py-0.5 bg-success-soft border border-success/20 rounded-md text-[9px] font-black uppercase tracking-wider text-success font-mono"
        >
          <span class="w-1 h-1 rounded-full bg-success animate-pulse"></span> {{ 'accountsInformation.badges.verified' | translate }}
        </span>
      </div>
    </div>
  `,
})
export class AccountContactCardComponent {
  @Input() responseTime: string = 'accountsInformation.contact.withinOneHour';
  @Input() phoneNumber: string = '';
  @Input() email: string = '';
  @Input() accountType: string = '';

  get contactTitle(): string {
    const type = this.accountType?.toLowerCase?.() || '';
    if (type === 'broker') {
      return 'accountsInformation.contact.titleBroker';
    } else if (type === 'real_estate_developer' || type === 'developer') {
      return 'accountsInformation.contact.titleDeveloper';
    } else if (type === 'property_seeker' || type === 'seeker') {
      return 'accountsInformation.contact.titleSeeker';
    } else {
      return 'accountsInformation.contact.titleOwner';
    }
  }
}
